<div class="PGLoginHandlerOTP">
    @if (isLoading) {
        <app-pg-loading [isOverlay]="true"></app-pg-loading>
    }
    @if (!loginOTPSent) {
        <div class="form-group">
            <label id="pg-login-otp-contact-label" for="pg-login-otp-contact">
                <b>{{ (disablePhone ? 'pg-login-handler.input-email' : 'pg-login-handler.input-contact') | locTranslate }}</b>
            </label>
            <app-pg-recipient id="pg-login-otp-contact" [(ngModel)]="loginOTPRecipient" [readonly]="loginOTPSent" (viaChange)="loginOTPVia = $event" (keyup)="onLoginOTPKeyUp($event)"></app-pg-recipient>
        </div>
        @if (loginOTPSendError) {
            <div class="form-group">
                <div class="text-danger" role="alert">{{ 'pg-login-handler.otp-failed' | locTranslate }}</div>
            </div>
        }
        <button type="button" class="btn btn-primary btn-block" [disabled]="!canSendOTP()" (click)="sendOTP()">
            <i class="fa-regular fa-paper-plane" aria-hidden="true"></i>
            <span>{{ 'pg-login-handler.button-otp' | locTranslate }}</span>
        </button>
    }
    @if (loginOTPSent) {
        @if (!noBack) {
            <div class="mb-3">
                <button type="button" class="btn btn-link btn-sm p-0" (click)="resetOTP()">
                    <i class="fa-regular fa-chevron-left" aria-hidden="true"></i>
                    <span>{{ 'pg-login-handler.edit-contact' | locTranslate }}</span>
                </button>
            </div>
        }
        
        <div class="form-group">
            <div class="text-success" role="status">{{ 'pg-login-handler.otp-sent' | locTranslate:'recipient':loginOTPRecipient:'via':(loginOTPVia == 'email' ? 'email' : 'SMS') }}</div>
        </div>
        <div class="form-group">
            <label for="pg-login-otp-code">
                <b>{{ 'pg-login-handler.input-otp' | locTranslate }}</b>
            </label>
            <input id="pg-login-otp-code" class="form-control" [(ngModel)]="loginOTPVerify" (keyup)="onLoginOTPKeyUp($event)" autocomplete="one-time-code" inputmode="numeric" [attr.aria-invalid]="loginError || null" [attr.aria-describedby]="loginError ? 'pg-login-otp-error' : null"/>
        </div>
        <div class="form-group">
            @if (loginError) {
                <div id="pg-login-otp-error" class="text-danger" role="alert">{{ 'pg-login-handler.check-failed' | locTranslate }}</div>
            }
        </div>
        <button type="button" class="btn btn-primary btn-block" [disabled]="!canLoginOTP()" (click)="doLoginOTP()">
            <i class="fa-regular fa-sign-in-alt" aria-hidden="true"></i>
            <span>{{ 'pg-login-handler.button-check' | locTranslate }}</span>
        </button>
    }
</div>
